import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Testimonial from '../components/sections/Testimonial';
import Cta from '../components/sections/Cta';
import AboutUs from '../components/sections/about-us';
import ContactUs from '../components/sections/contact-us';

const Home = () => {

  return (
    <>
      <Hero className="illustration-section-01" />
      <FeaturesTiles />
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      <AboutUs topDivider />
      <ContactUs topDivider />
      <Testimonial topDivider />
      <Cta split />
    </>
  );
}

export default Home;